import * as React from 'react';
import { cn } from '@/lib/utils';

const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'>>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          'flex min-h-[60px] w-full rounded-md border border-input bg-input-background hover:border-input-hover placeholder:text-input-placeholder focus-visible:border-primary focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-input-focus-ring px-3 py-2 text-base text-foreground shadow-sm transition-colors disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Textarea.displayName = 'Textarea';
export { Textarea };
